import { Box, Grid, Typography } from '@mui/material';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RoundButton } from 'ui/Buttons';
import { EventsDocumentsModal } from './EventsDocumentsModal';

type EventsDocumentsControlProps = {
  label: string;
  value: any[];
  onChange: (value: any[]) => void;
};

export const EventsDocumentsControl: FC<EventsDocumentsControlProps> = ({
  label,
  value = [],
  onChange,
}) => {
  const { t } = useTranslation();
  const [showDocumentsModal, setShowDocumentsModal] = useState(false);

  const toggleDocumentsModal = () => setShowDocumentsModal(!showDocumentsModal);

  return (
    <Box mt={2}>
      <Grid container alignItems="center" spacing={1}>
        <Grid item>
          <Typography variant="body1" component="span">
            {t(label)}
          </Typography>
        </Grid>
        <Grid item>
          <Grid container alignItems="center">
            <EventsDocumentsModal
              documents={value}
              onChange={onChange}
              open={showDocumentsModal}
              onClose={toggleDocumentsModal}
            />
            {/* @ts-ignore */}
            <RoundButton label={t('Upload')} onClick={toggleDocumentsModal} marginRight />
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};
